// src/shared/hooks/useDebounce.js
import { useEffect, useState } from 'react';


/**
 * Hook para gerenciar valores com atraso de atualização (debounce). Útil para otimizar
 * chamadas em casos como busca em tempo real, onde queremos aguardar o usuário
 * terminar de digitar antes de realizar uma ação.
 *
 * @param value - Valor a ser debounced (ex: termo de busca)
 * @param delay - Tempo de espera em ms antes de atualizar o valor (padrão: 300ms)
 * @returns {unknown} - Valor atualizado após o delay
 */
export function useDebounce(value, delay = 300) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);
    return debounced;
}
